import { StringSchema } from 'yup';
import * as Yup from 'yup';
import { FormAction } from '../types';
import { SCRIPT_MAX_LENGTH } from './AISpotlightForm';

export const SpotlightSchema = Yup.object().shape({
  text: Yup.string().when('action', {
    // Validation runs if action is NOT SCRIPT_UPSERT
    is: (action: string | undefined) => action !== FormAction.SCRIPT_UPSERT,
    then: (schema: StringSchema<string | undefined>) =>
      schema
        .max(
          SCRIPT_MAX_LENGTH,
          `Script cannot exceed ${SCRIPT_MAX_LENGTH} characters.`
        )
        .required('Script text is required.'),
    otherwise: (schema: StringSchema<string | undefined>) =>
      schema.notRequired(),
  }),

  action: Yup.string() as Yup.Schema<
    typeof FormAction.SUBMIT | typeof FormAction.SCRIPT_UPSERT | undefined
  >,
});
